<template>
  <el-button size="mini" plain :loading="loading" @click="onClick">Fetch Nutrients</el-button>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
    }
  },
  props: {
    recipeId: String
  },
  methods: {
    async onClick() {
      this.loading = true
      try {
        var { data } = await this.$http.post(`/recipes/${ this.recipeId }/nutrient`)
      } catch(err) {
        this.$message.error(err.response.data.message)
        return false
      } finally {
        this.loading = false
      }
      this.$message.success(data.message)
    },
  },
}
</script>
